<div class="title-bar">Add Authorized Party</div>
<router-outlet></router-outlet>